export const AVIALABLE_LANG = [
    'en',
    'it',
    'de',
    'fr',
    'es'
]